import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=022a6b1e&scoped=true&"
import script from "./PaymentPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPopup.vue?vue&type=style&index=0&id=022a6b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a6b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022a6b1e')) {
      api.createRecord('022a6b1e', component.options)
    } else {
      api.reload('022a6b1e', component.options)
    }
    module.hot.accept("./PaymentPopup.vue?vue&type=template&id=022a6b1e&scoped=true&", function () {
      api.rerender('022a6b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/PaymentPopup.vue"
export default component.exports